<template>
  <wrap />
</template>

<script setup>
import Wrap from '@/components/views/index';
import { watch } from 'vue';
import store from '@/store';
import router from '@/router';

watch(
  () => store.getters['layout/initMovePath'],
  async value => {
    if (value) {
      store.commit('layout/setInitMovePath');
      await router.push(value);
    }
  }
);
</script>
<style scoped></style>
